import React, { createContext, useState, useContext, useEffect, useRef } from 'react';
import { authAPI, usersAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const heartbeatInterval = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  // Heartbeat to track online status
  useEffect(() => {
    if (user) {
      const sendHeartbeat = async () => {
        try {
          await usersAPI.heartbeat();
        } catch (error) {
          console.error('Heartbeat failed:', error);
        }
      };

      // Send immediately on login/mount
      sendHeartbeat();

      // Send every 30 seconds
      heartbeatInterval.current = setInterval(sendHeartbeat, 30000);

      return () => {
        if (heartbeatInterval.current) {
          clearInterval(heartbeatInterval.current);
        }
      };
    }
  }, [user]);

  const login = async (username, password) => {
    const response = await authAPI.login(username, password);
    const { token, user } = response.data;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
